import { useMemo } from 'react';
import { IBestDataset } from '../../../../../types/analytics';

export const useDatasetCategories = (datasets: IBestDataset[]): string[] =>
  useMemo(
    () => Array.from(new Set(datasets.map((dataset) => dataset.label))),
    [datasets]
  );
